export { a as createReactDecoration, c as createRootHooks, b as createUseQueries, g as getClientArgs } from '../createHooksInternal-3d8ebfcf.mjs';
export { T as TRPCContext, d as contextProps, c as createReactQueryUtils, b as getQueryType } from '../utilsProxy-00894da2.mjs';
export { g as getQueryClient } from '../queryClient-4d766c0c.mjs';
import '@trpc/server/shared';
import '@tanstack/react-query';
import '@trpc/client';
import 'react';
